import { render, staticRenderFns } from "./AllRelease.vue?vue&type=template&id=5c2ae8ea&"
import script from "./AllRelease.vue?vue&type=script&lang=js&"
export * from "./AllRelease.vue?vue&type=script&lang=js&"
import style0 from "./AllRelease.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports